import React from 'react';
import "@/App.css";
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from 'sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import TrustSection from './components/TrustSection';
import ForCompaniesSection from './components/ForCompaniesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Toaster position="top-right" richColors />
        <Header />
        <main>
          <HeroSection />
          <AboutSection />
          <ServicesSection />
          <TrustSection />
          <ForCompaniesSection />
          <ContactSection />
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </LanguageProvider>
  );
}

export default App;
